import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";

import Dashboard from "@/pages/Dashboard/Dashboard.vue";
import UserProfile from "@/pages/UserProfile/UserProfile.vue";
import FinancialHistory from "@/pages/FinancialHistory/FinancialHistory.vue";
import Login from "@/pages/Auth/Login.vue";
import UpdatePlan from "@/pages/UpdatePlan/UpdatePlan.vue";
import Services from "@/pages/Services/Services.vue";
import Ticket from "@/pages/Ticket/Ticket.vue";
import Contracts from "@/pages/Contracts/Contracts.vue";
import TicketList from "@/pages/Ticket/TicketList.vue";
import TicketForm from "@/pages/Ticket/TicketForm.vue";
import TicketView from "@/pages/Ticket/TicketView.vue";
import Wifi from "@/pages/Wifi/Wifi.vue";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard
      },
      {
        path: "profile",
        name: "Meu Perfil",
        component: UserProfile
      },
      {
        path: "services",
        name: "Serviços Contratados",
        component: Services
      },
      {
        path: "history",
        name: "Histórico Financeiro",
        component: FinancialHistory
      },
      {
        path: "contracts",
        name: "Contratos Pendentes",
        component: Contracts
      },
      {
        path: "wifi",
        name: "Configuração do meu Wi-Fi",
        component: Wifi
      },
      // {
      //   path: "tickets",
      //   component: Ticket,
      //   children: [
      //     {
      //       path: "/",
      //       name: "Lista de atendimentos",
      //       component: TicketList
      //     },
      //     {
      //       path: "create",
      //       name: "Abertura de chamado",
      //       component: TicketForm
      //     },
      //     {
      //       path: ":id/view",
      //       name: "Visualizar chamado",
      //       component: TicketView
      //     }
      //   ]
      // },
      {
        path: "/update-plan",
        name: "Atualização de Plano",
        component: UpdatePlan
      }
    ]
  }
];

export default routes;
